import { NavigationProp, useNavigation } from "@react-navigation/native";
import Button from "components/Button";
import { useAccount } from "hooks/useAccount";
import useCurrentUser from "hooks/useCurrentUser";
import { MainFlowParamList } from "navigation/types";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import React from "react";
import { View } from "react-native";
import { getUniqSubscriptions } from "utils/subscriptionUtils";

const QuickActions = () => {
  const navigation = useNavigation<NavigationProp<MainFlowParamList>>();
  const { account } = useAccount();
  const { currentMember } = useCurrentUser();
  const { data: tenantOptions } = useFetchTenantConfigurationQuery();
  const uniqSubscriptions = getUniqSubscriptions(account?.subscriptions || []);

  if (!currentMember) return null;
  return (
    <View
      style={{
        flexDirection: "row",
      }}
    >
      {uniqSubscriptions.length === 0 ? (
        <Button
          style={{ flex: 1 }}
          appearance="outline"
          onPress={() => {
            navigation.navigate("Account", {
              screen: "ManageSubscriptions",
              params: {
                screen: "SubscriptionDetail",
                params: {
                  memberId: String(currentMember.id),
                },
              },
            });
          }}
        >
          Purchase Plan
        </Button>
      ) : (
        <>
          {tenantOptions?.ctaButtonText && (
            <Button
              style={{ flex: 1, marginBottom: 14 }}
              appearance="outline"
              onPress={() => {
                navigation.navigate("Schedule", {
                  screen: "ScheduleScreen",
                });
              }}
              testID="cta-button"
            >
              {tenantOptions?.ctaButtonText}
            </Button>
          )}
        </>
      )}
    </View>
  );
};

export default QuickActions;
